import { Image } from '@chakra-ui/react';

const SectionImage = ({ src, alt }: { src: string; alt: string }) => (
  <Image
    src={src}
    alt={alt}
    width="100%"
    maxHeight="420px"
    objectFit="cover"
    borderRadius="14px"
    border="2px solid"
    borderColor="primary.200"
  />
);

export default SectionImage;
